/* ============================================================
   FLOORING ATTIC — morphing sticky header (production)
   Loaded from sections/header.liquid via:
     <script src="{{ 'fa-sticky-morph.js' | asset_url }}" defer></script>
   Behavior (desktop >= 990px):
   - The top header row scrolls away with the page (sticky offset
     = top-row height) — ONLY the red nav bar ever stays pinned,
     so no content is covered at any point of the transition
   - As the bar takes over, the logo+search cluster slides in
     from the left edge and the about/account/cart cluster from
     the right ("slide from edges" entrance)
   - Cloned About/Account dropdowns, cart + wishlist hover
     panels, click-to-open predictive search, self-correcting
     content-edge alignment
   - v2 (Aug 2026): the search panel now replicates the MAIN
     header search box — it fetches the server-rendered
     predictive-search section and injects fa-product-card
     'panel' horizontal cards instead of templating bare rows
     from suggest.json
   ============================================================ */
(() => {
  const init = () => {
  if (window.__faMorph) return;
  const myGen = window.__faMorphGen = (window.__faMorphGen || 0) + 1;
  const LERP = 0.22;
  const BAND = 1440;
  const PAD = 40;
  const LOGO_H = 28;

  const BRAND_LOGOS = {
    // 'lifeproof': 'https://flooringattic.com/cdn/shop/files/....png',
  };

  const hdr = document.querySelector('#header-component');
  const topRow = hdr?.querySelector('.header__row--top');
  const botRow = hdr?.querySelector('.header__row--bottom');
  const cols = topRow?.querySelector('.header__columns');
  const section = hdr?.closest('.header-section');
  if (!hdr || !topRow || !botRow || !cols || !section) {
    console.warn('FA morph: header elements not found', { hdr, topRow, botRow, section });
    return;
  }

  section.style.position = 'sticky';
  section.style.zIndex = 'var(--layer-sticky, 100)';

  const style = document.createElement('style');
  style.id = 'fa-morph-style';
  style.textContent = `
  @media screen and (min-width: 990px) {
    /* the theme's sticky-state machinery must not fight the morph */
    #header-component, .header-section {
      transform: none !important; opacity: 1 !important;
    }
    #header-component { transition: none !important; }
    .header__row--bottom { position: relative; transition: box-shadow 150ms ease; }
    /* our position:relative on the bar changed paint order — lift the top
       row so its own dropdown panels overlay the bar at rest */
    .header__row--top { position: relative; z-index: 4; }
    .header__row--top .header__columns { will-change: transform, opacity; }

    .fa-morph-ui {
      position: absolute; top: 50%; left: 0;
      display: flex; align-items: center;
      opacity: 0; pointer-events: none; white-space: nowrap; z-index: 3;
      transform: translateY(-50%); will-change: transform, opacity;
    }
    .fa-morph-left { gap: 26px; }
    .fa-morph-icons { gap: 22px; }
    .fa-morph-logo { line-height: 0; }
    .fa-morph-logo svg { height: __LOGO_H__px; width: auto; display: block; }
    .fa-morph-logo svg text { fill: rgba(255,255,255,.82) !important; }

    .fa-morph-ui .fa-action {
      display: inline-flex; align-items: center;
      color: #fff; text-decoration: none; line-height: 1;
      padding: 8px 6px; margin: -8px -6px;
      background: none; border: 0; cursor: pointer;
      transition: opacity 160ms ease;
    }
    .fa-morph-ui .fa-action:hover,
    .fa-morph-ui .fa-dd:hover > .fa-action,
    .fa-morph-ui .fa-morph-search.open > .fa-action { opacity: .65; }
    .fa-morph-ui .fa-action__text {
      display: inline; color: #fff; font-size: 12.5px; font-weight: 600;
      letter-spacing: .03em; text-transform: uppercase; margin-left: 7px; line-height: 1;
    }
    .fa-morph-ui .fa-action__chev {
      display: inline-block; color: #fff; margin-left: 5px; font-size: 11px; line-height: 1;
    }
    .fa-morph-ui .fa-action > svg,
    .fa-morph-ui .fa-action__icon svg {
      stroke: #fff !important; color: #fff !important; fill: none !important;
      width: 20px !important; height: 20px !important;
    }
    .fa-morph-ui .fa-dd__panel { top: calc(100% + 20px); line-height: 1.45; }
    .fa-morph-ui .fa-dd__link { color: rgba(0,0,0,0.81) !important; }

    .fa-morph-search { position: relative; display: inline-flex; line-height: 0; }
    .fa-morph-searchpanel {
      position: absolute; top: calc(100% + 20px); left: -8px;
      width: min(660px, calc(100vw - 60px)); /* v2 was 420px — panel cards need lanes */
      background: #fff; border: 1px solid rgba(0,0,0,.12);
      box-shadow: 0 12px 30px rgba(0,0,0,.12); padding: 8px; z-index: 999;
      opacity: 0; visibility: hidden; transform: translateY(6px);
      transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
      line-height: 1.4;
    }
    .fa-morph-search.open .fa-morph-searchpanel { opacity: 1; visibility: visible; transform: translateY(0); }
    .fa-morph-searchpanel form { display: flex; align-items: stretch; gap: 8px; }
    .fa-morph-searchpanel input[type="search"] {
      flex: 1; min-width: 0; border: 1px solid #ccc; background: #fff;
      color: rgba(0,0,0,0.81); font-size: 14px; padding: 10px 12px;
      border-radius: 0; outline: none;
    }
    .fa-morph-searchpanel input[type="search"]:focus { border-color: #d21f26; }
    .fa-morph-searchpanel button[type="submit"] {
      background: #d21f26; border: 0; color: #fff; cursor: pointer;
      padding: 0 16px; display: flex; align-items: center; border-radius: 0;
    }
    .fa-morph-searchpanel button[type="submit"]:hover { background: #b81b21; }
    .fa-morph-searchpanel button[type="submit"] svg { stroke: #fff; fill: none; width: 18px; height: 18px; }
    .fa-morph-searchresults { max-height: min(64vh, 620px); overflow: auto; } /* v2 was 340px */
    .fa-morph-searchresults .fa-cartp__item:last-of-type { border-bottom: 0; }

    /* v2 — injected panel-card stack (same rules as the main header flyout;
       they live HERE because this style tag is page-loaded, while any CSS
       riding inside the fetched section fragment gets discarded) */
    .fa-morph-searchresults #predictive-search-products {
      padding: 8px 2px 4px;
    }
    .fa-morph-searchresults .predictive-search-results__wrapper-products {
      display: flex !important;
      flex-direction: column !important;
      flex-wrap: nowrap !important;
      gap: 10px !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }
    .fa-morph-searchresults .predictive-search-results__card--product {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      flex: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    .fa-morph-searchresults .predictive-search-results__card--product .fa-hcard {
      width: 100% !important;
    }
    .fa-morph-searchresults .predictive-search-results__card--product:hover,
    .fa-morph-searchresults .predictive-search-results__card--product:active {
      background: transparent !important;
      padding: 0 !important;
      margin: 0 !important;
      transform: none !important;
    }

    .fa-morph-searchall {
      display: block; text-align: center; font-size: 12.5px; font-weight: 600;
      color: #d21f26 !important; text-decoration: none; padding: 9px 4px 4px;
      letter-spacing: .03em; text-transform: uppercase;
    }
    .fa-morph-searchall:hover { text-decoration: underline; }

    .fa-morph-cartpanel { width: 320px; }
    .fa-cartp__items { max-height: 300px; overflow: auto; }
    .fa-cartp__item {
      display: flex; align-items: center; gap: 10px;
      padding: 8px 4px; border-bottom: 1px solid rgba(0,0,0,.08);
      color: rgba(0,0,0,0.81);
    }
    .fa-cartp__item img.fa-cartp__thumb { width: 44px; height: 44px; object-fit: cover; flex-shrink: 0; }
    .fa-cartp__info { min-width: 0; }
    .fa-cartp__brand img { height: 13px; width: auto; display: block; margin-bottom: 3px; }
    .fa-cartp__brandtext {
      font-size: 10px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase;
      color: rgba(0,0,0,.45); margin-bottom: 2px;
    }
    .fa-cartp__title {
      font-size: 13px; font-weight: 600; overflow: hidden;
      text-overflow: ellipsis; white-space: nowrap;
    }
    .fa-cartp__meta { font-size: 12px; color: rgba(0,0,0,.55); margin-top: 2px; }
    .fa-cartp__line { margin-left: auto; font-size: 13px; font-weight: 600; flex-shrink: 0; }
    .fa-cartp__foot {
      display: flex; justify-content: space-between; align-items: center;
      padding: 10px 4px; font-size: 13px; color: rgba(0,0,0,0.81);
    }
    .fa-cartp__btn {
      display: block; text-align: center; background: #d21f26; color: #fff !important;
      font-weight: 700; font-size: 13px; letter-spacing: .04em; text-transform: uppercase;
      padding: 11px; text-decoration: none;
    }
    .fa-cartp__btn:hover { background: #b81b21; }
    .fa-cartp__empty { padding: 14px 4px; font-size: 13px; color: rgba(0,0,0,.6); }
    .fa-morph-ui .fa-morph-cart-count {
      position: absolute; top: -7px; right: -9px;
      background: #fff; color: #d21f26;
      font: 600 10px/1 Inter, sans-serif;
      min-width: 15px; height: 15px; padding: 0 3px;
      display: flex; align-items: center; justify-content: center;
      border-radius: 999px;
    }
    .fa-morph-ui .fa-morph-cart-count:empty { display: none; }

    .fa-morph-wlpanel {
      position: absolute; top: calc(100% + 15px); width: 320px;
      background: #fff; border: 1px solid rgba(0,0,0,.12);
      box-shadow: 0 12px 30px rgba(0,0,0,.12); padding: 8px; z-index: 999;
      opacity: 0; visibility: hidden; transform: translateY(6px);
      transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
      line-height: 1.45;
    }
    .fa-morph-wlpanel.open { opacity: 1; visibility: visible; transform: translateY(0); }
  }`.replace('__LOGO_H__', LOGO_H);
  document.body.appendChild(style);

  function brandHTML(vendor) {
    if (!vendor) return '';
    const url = BRAND_LOGOS[vendor.toLowerCase().trim()];
    if (url) return '<div class="fa-cartp__brand"><img src="' + url + '" alt="' + vendor + '"></div>';
    return '<div class="fa-cartp__brandtext">' + vendor + '</div>';
  }

  /* ---------- About Us panel icons ---------- */
  const ICONS = {
    calendar: '<path d="M8 2v4M16 2v4M3 10h18"/><rect x="3" y="4" width="18" height="18" rx="0"/>',
    phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>',
    pin: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
    users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
    star: '<path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>',
    card: '<rect x="1" y="4" width="22" height="16"/><path d="M1 10h22"/>',
    help: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01"/>',
    doc: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>',
    briefcase: '<rect x="2" y="7" width="20" height="14"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>',
    store: '<path d="M4 7l1.2-3h13.6L20 7"/><path d="M4 7h16v14H4z"/><path d="M9 21V12h6v9"/><path d="M8 7a2 2 0 0 0 4 0"/><path d="M12 7a2 2 0 0 0 4 0"/><path d="M16 7a2 2 0 0 0 4 0"/>',
    buildings: '<path d="M3 21h18"/><path d="M5 21V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v16"/><path d="M12 21V11a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10"/><path d="M8 8h.01M8 12h.01M8 16h.01M16 14h.01M16 17.5h.01"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>',
  };
  function aboutIconFor(title) {
    const t = (title || '').toLowerCase();
    if (/family|afdc|companies|division|brands/.test(t)) return ICONS.buildings;
    if (/event|calendar|sale|closeout/.test(t)) return ICONS.calendar;
    if (/contact|phone|call|email/.test(t)) return ICONS.phone;
    if (/location|direction|visit|showroom|find us|hours/.test(t)) return ICONS.pin;
    if (/team|meet|staff|who we/.test(t)) return ICONS.users;
    if (/review|testimonial/.test(t)) return ICONS.star;
    if (/financ|credit|payment/.test(t)) return ICONS.card;
    if (/faq|help|support/.test(t)) return ICONS.help;
    if (/blog|news|article|guide|resource/.test(t)) return ICONS.doc;
    if (/career|job|hiring/.test(t)) return ICONS.briefcase;
    if (/about|story|company/.test(t)) return ICONS.store;
    return ICONS.info;
  }
  function addAboutIcons(panel) {
    if (!panel) return;
    panel.querySelectorAll('svg.fa-morph-aicon').forEach((n) => n.remove());
    panel.querySelectorAll('.fa-dd__link').forEach((link) => {
      if (link.querySelector('svg')) return;
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'fa-morph-aicon');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.innerHTML = aboutIconFor(link.textContent);
      link.prepend(svg);
    });
  }
  const origAboutPanel = document.querySelector('.fa-header-top__about .fa-dd .fa-dd__panel');
  addAboutIcons(origAboutPanel);

  /* ---------- LEFT cluster ---------- */
  const leftBox = document.createElement('div');
  leftBox.className = 'fa-morph-ui fa-morph-left';
  const logo = document.createElement('div');
  logo.className = 'fa-morph-logo';
  logo.innerHTML = `<svg viewBox="0 0 3840 1211" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"><g id="OG"></g><rect id="Flooring-Attic-Alternate" serif:id="Flooring Attic Alternate" x="0" y="0" width="3840" height="1210.86" style="fill:none;"/><clipPath id="_clip1"><rect x="0" y="0" width="3840" height="1210.86"/></clipPath><g clip-path="url(#_clip1)"><g><g transform="matrix(1,0,0,0.979502,0,-1617.29)"><g transform="matrix(722.873,0,0,722.873,3770.31,2571.52)"></g><text x="2386.47px" y="2571.52px" style="font-family:'SignPainter-HouseScriptSemibold', 'SignPainter';font-size:722.873px;fill:#6b6c6e;">O<tspan x="2771.3px " y="2571.52px ">u</tspan>tlet</text></g><g transform="matrix(1,0,0,0.927485,0,-1122.11)"><g transform="matrix(158.239,0,0,158.239,3837.37,2359.76)"></g><text x="2392.74px" y="2359.76px" style="font-family:'GillSans-BoldItalic', 'Gill Sans', sans-serif;font-weight:700;font-style:italic;font-size:158.239px;fill:#6b6c6e;">A Di<tspan x="2720.27px 2802.25px " y="2359.76px 2359.76px ">vi</tspan>sion of<tspan x="3377.49px 3423.69px " y="2359.76px 2359.76px "> A</tspan>FDC</text></g><g id="Vector-1" serif:id="Vector 1"><g id="Attic"><path d="M2256.7,648.787c0,-0 -43.476,-64.601 -113.843,-63.295c-64.958,1.205 -118.619,47.063 -121.156,108.072c-4.119,99.064 43.566,152.815 110.572,155.186c60.161,2.13 90.606,-21.968 126.19,-62.244c0.138,-0.156 0.332,-0.25 0.54,-0.263c0.208,-0.013 0.412,0.058 0.568,0.196l115.524,102.522c0.157,0.138 0.251,0.334 0.262,0.543c0.012,0.209 -0.061,0.414 -0.202,0.569c0,-0 -42.238,46.563 -89.354,72.308c-30.744,16.799 -86.388,34.72 -168.815,34.157c-60.078,-0.411 -130.231,-25.009 -172.279,-57.67c-55.829,-43.366 -78.541,-85.865 -93.721,-129.384c-11.721,-33.602 -36.373,-152.947 34.924,-251.484c68.774,-95.051 169.737,-118.258 235.88,-118.171c23.017,0.031 161.994,-11.297 253.504,106.007c0.256,0.329 0.211,0.8 -0.104,1.074l-117.325,102.03c-0.17,0.148 -0.394,0.215 -0.617,0.186c-0.223,-0.029 -0.422,-0.153 -0.548,-0.339Z" style="fill:#fff;"/><path d="M1789.29,442.55l-0,539.585c-0,0.447 -0.362,0.809 -0.809,0.809l-181.55,0c-0.447,0 -0.809,-0.362 -0.809,-0.809l0,-539.585c0,-0.447 0.362,-0.809 0.809,-0.809l181.55,-0c0.447,-0 0.809,0.362 0.809,0.809Z" style="fill:#fff;"/><path d="M707.072,584.224l-154.7,0.111c-0.445,0 -0.806,-0.36 -0.807,-0.806l-0.121,-140.986c0,-0.214 0.085,-0.419 0.236,-0.57c0.151,-0.152 0.356,-0.237 0.57,-0.237l497.033,-0.284c0.444,-0.001 0.804,0.357 0.807,0.8l1.035,141.159c0.001,0.215 -0.083,0.421 -0.234,0.574c-0.152,0.152 -0.358,0.238 -0.572,0.238l-159.687,0l-0.008,398c0,0.213 -0.085,0.418 -0.236,0.57c-0.151,0.151 -0.356,0.236 -0.57,0.236l-181.944,-0.064c-0.445,-0 -0.805,-0.361 -0.805,-0.806l0.003,-397.935Z" style="fill:#fff;"/><path d="M1420.23,584.224l0.004,397.935c-0,0.445 -0.361,0.806 -0.806,0.806l-181.944,0.064c-0.213,-0 -0.419,-0.085 -0.57,-0.236c-0.151,-0.152 -0.236,-0.357 -0.236,-0.57l-0.007,-398l-159.687,0c-0.215,0 -0.421,-0.086 -0.572,-0.238c-0.152,-0.153 -0.236,-0.359 -0.234,-0.574l1.034,-141.159c0.004,-0.443 0.364,-0.801 0.807,-0.8l497.033,0.284c0.214,0 0.419,0.085 0.57,0.237c0.151,0.151 0.236,0.356 0.236,0.57l-0.121,140.986c-0,0.446 -0.361,0.806 -0.807,0.806l-154.7,-0.111Z" style="fill:#fff;"/><g id="A"><path d="M10.943,984.328l-10.943,0l4.066,-9.461c0.091,-0.321 0.204,-0.638 0.339,-0.948l230.881,-529.128c1.183,-2.712 3.86,-4.464 6.819,-4.464l171.036,0.004c2.96,0.001 5.639,1.756 6.82,4.471l227.289,522.224l0.006,-0.006l7.59,17.308l-10.64,0c-0.255,0.026 -0.512,0.039 -0.77,0.039l-166.097,-0.236l0.217,0.197l-14.937,0l-1.589,-4.019c-0.164,-0.294 -0.309,-0.601 -0.434,-0.921l-34.529,-88.258l-200.41,0.007l-35.203,88.489c-0.075,0.189 -0.157,0.373 -0.246,0.553l-1.641,4.149l-14.936,0l0.013,-0.012l-162.42,0.018c-0.094,-0 -0.187,-0.002 -0.281,-0.006Zm315.841,-353.643c-2.54,-0.007 -3.046,1.387 -3.046,1.387l-47.313,122.189c-0,-0 -1.023,2.593 -0.016,3.84c0.998,1.237 4.068,0.89 4.068,0.89l89.548,-0c0,-0 3.623,0.369 4.731,-2.834c0.696,-2.012 -0.699,-7.15 -0.699,-7.15l-44.542,-117.123c-0,0 -0.625,-1.193 -2.731,-1.199Z" style="fill:#fff;stroke:#000;stroke-width:0.5px;"/></g></g><g id="Flooring"><g id="F"><path d="M242.354,390.53l-0,5.674l41.577,-0l-0,-107.24l132.942,0l-0,-40.917l-132.091,-0l-0,-84.902l148.642,-0l0,-39.434l-199.688,0l0,262.069l9.03,-0l-0.412,4.75Z"/><path d="M230.489,118.237l0,272.293l40.388,0l0,-108.75l134.147,0l0,-38.418l-134.202,0l0,-88.618l148.524,-0l0,-36.451l-188.857,-0.056Z" style="fill:#fff;"/></g><g id="L"><path d="M498.808,382.016l0,14.188l186.674,-0l0,-35.127l-144.763,0l0,-234.414l-25.06,-0l0,225.174l-16.851,30.179Z"/><path d="M485.598,118.237l-0,269.092l185.484,0l0,-33.495l-143.884,0l0,-235.597l-41.6,0Z" style="fill:#fff;"/></g><g id="O"><path d="M857.018,121.988c81.945,-0 144.245,51.751 144.245,137.108c0,85.357 -64.513,140.217 -144.124,140.217c-79.612,-0 -144.366,-64.545 -144.366,-140.217c-0,-88.087 64.634,-137.108 144.245,-137.108Zm-0,37.256c37.179,0 102.378,26.805 102.074,99.852c-0.23,55.254 -47.675,100.448 -103.902,100.714c-39.805,0.188 -99.547,-29.756 -99.547,-100.714c0,-65.427 61.569,-99.852 101.375,-99.852Z"/><path d="M843.905,116.355c81.946,0 144.246,52.705 144.246,139.635c-0,77.067 -64.634,139.635 -144.246,139.635c-79.611,0 -144.245,-62.568 -144.245,-139.635c-0,-89.709 64.634,-139.635 144.245,-139.635Zm0,36.474c37.179,0 102.379,28.768 102.075,103.161c-0.23,56.273 -45.848,97.199 -102.075,97.47c-39.805,0.191 -101.374,-30.837 -101.374,-97.47c-0,-74.433 61.569,-103.161 101.374,-103.161Z" style="fill:#fff;"/></g><g id="O1" serif:id="O"><path d="M1192.03,120.144c81.945,0 144.245,51.751 144.245,137.108c0,85.357 -64.513,140.217 -144.124,140.217c-79.612,0 -144.366,-64.545 -144.366,-140.217c-0,-88.086 64.634,-137.108 144.245,-137.108Zm-0,37.257c37.179,-0 102.378,26.804 102.074,99.851c-0.23,55.254 -47.675,100.449 -103.902,100.714c-39.805,0.188 -99.547,-29.756 -99.547,-100.714c0,-65.427 61.569,-99.851 101.375,-99.851Z"/><path d="M1178.91,114.512c81.946,-0 144.246,52.705 144.246,139.635c-0,77.066 -64.634,139.635 -144.246,139.635c-79.611,-0 -144.245,-62.569 -144.245,-139.635c-0,-89.71 64.634,-139.635 144.245,-139.635Zm0,36.474c37.179,-0 102.379,28.767 102.075,103.161c-0.23,56.272 -45.848,97.199 -102.075,97.469c-39.805,0.191 -101.374,-30.836 -101.374,-97.469c-0,-74.433 61.569,-103.161 101.374,-103.161Z" style="fill:#fff;"/></g><g id="R"><path d="M1407.91,383.381l6.412,-254.395l103.587,-9.195c3.005,0.003 5.927,0.094 8.768,0.268c80.116,4.881 95.803,74.909 96.057,79.952c0.402,7.998 4.152,40.72 -6.116,62.389c-15.303,32.295 -49.548,44.383 -49.548,44.383l64.244,89.421l-46.903,-0l-60.469,-82.358l-77.142,0l-0,82.358l-38.89,-0l-0,-12.823Zm40.022,-220.747l0.036,110.891l82.594,-0.86c0,0 39.191,-9.719 38.476,-61.544c-0.379,-27.53 -24.395,-47.586 -41.595,-48.563l-79.511,0.076Z"/><path d="M1526.68,120.059c9.625,1.911 53.246,5.231 74.3,48.596c19.277,39.705 8.637,69.424 0.694,88.257c-12.774,30.285 -47.589,41.115 -47.589,41.115l62.536,92.667l-38.427,0l-62.775,-86.473l-82.822,0l-0,85.11l-41.457,0l0,-271.094l133.993,1.408c0.318,0.141 0.841,0.273 1.547,0.414Zm-95.312,33.678l-0,116.245l88.716,0c-0,0 49.672,-7.036 48.957,-58.861c-0.379,-27.53 -25.453,-56.461 -42.653,-57.438l-95.02,0.054Z" style="fill:#fff;"/></g><g id="I"><path d="M1698.26,382.9l-0,13.304l39.41,-0l-0,-273.098l-32.862,0l-6.548,259.794Z"/><rect x="1683.9" y="118.237" width="41.81" height="272.457" style="fill:#fff;"/></g><g id="N"><path d="M1829.61,383.873l-0,12.331l42.609,-0l0,-197.518l12.869,-14.861l126.057,198.689c-0,0 11.921,13.74 24.631,13.69c12.888,-0.051 26.262,-0 26.262,-0l0,-270.837l-48.586,0l-0.807,180.672l-134.857,-167.546c0,0 -15.068,-20.154 -34.222,-19.694c-18.214,0.437 -13.956,265.074 -13.956,265.074Z"/><path d="M1817.68,118.237l0,271.108l39.569,-0l-0,-198.737l150.988,189.763c-0,0 8.721,9.966 21.374,10.323c9.047,0.255 20.366,0 20.366,0l0,-272.457l-42.219,0l1.937,191.236l-150.215,-181.28c-0,-0 -6.515,-9.064 -17.128,-9.956c-10.474,-0.879 -24.672,0 -24.672,0Z" style="fill:#fff;"/></g><g id="G"><path d="M2357.98,257.498l21.457,-0l-0,107.501c-0,-0 -34.645,32.208 -95.048,34.314c-60.404,2.106 -91.538,-21.468 -110.844,-36.611c-19.306,-15.144 -37.13,-138.563 -37.13,-138.563l26.584,-49.668l34.923,-16.576l31.026,-20.922l48.528,-6.042l41.762,6.471l20.345,-3.114c-0,0 26.04,6.994 41.924,32.132l-25.593,25.94c-0,0 -28.07,-26.781 -52.968,-30.458c-24.899,-3.677 -61.221,0.907 -81.75,13.792c-19.104,11.991 -32.396,27.491 -38.9,48.322c-6.504,20.831 -8.277,31.927 -4.404,57.95c3.872,26.023 32.764,68.499 76.29,73.167c43.527,4.667 86.927,-20.177 86.927,-20.177l1.101,-32.751l15.77,-44.707Z"/><path d="M2326.48,250.766l0.112,87.161c0,-0 -26.264,19.241 -78.239,14.014c-48.726,-4.901 -71.405,-44.672 -75.713,-52.855c-1.452,-2.759 -27.723,-54.799 4.091,-101.176c27.885,-40.65 75.333,-45.023 81.823,-44.991c30.626,0.151 49.271,3.419 88.577,31.628l23.005,-28.391c-0,0 -19.391,-26.148 -60.932,-35.841c-41.541,-9.693 -85.491,-4.331 -103.863,3.727c-18.373,8.058 -42.123,18.481 -67.243,57.838c-25.121,39.357 -19.619,81.205 -15.659,103.037c3.961,21.831 20.662,57.791 53.333,81.513c32.671,23.721 77.806,26.648 100.75,24.391c22.944,-2.256 59.754,-6.339 86.852,-30.867l0.161,-109.188l-37.055,-0Z" style="fill:#fff;"/></g></g></g></g></g></svg>`;
  leftBox.appendChild(logo);

  const searchDD = document.createElement('div');
  searchDD.className = 'fa-morph-search';
  searchDD.innerHTML =
    '<button type="button" class="fa-action" aria-label="Search" aria-expanded="false">' +
    '<svg viewBox="0 0 24 24" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg>' +
    '<span class="fa-action__text">Search</span>' +
    '</button>' +
    '<div class="fa-morph-searchpanel">' +
    '<form action="/search" method="get">' +
    '<input type="search" name="q" placeholder="Search products..." autocomplete="off">' +
    '<button type="submit" aria-label="Submit search">' +
    '<svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg>' +
    '</button>' +
    '</form>' +
    '<div class="fa-morph-searchresults"></div>' +
    '</div>';
  leftBox.appendChild(searchDD);

  const searchBtn = searchDD.querySelector('button[type="button"]');
  const searchInput = searchDD.querySelector('input[type="search"]');
  const searchResults = searchDD.querySelector('.fa-morph-searchresults');
  function setSearchOpen(open) {
    searchDD.classList.toggle('open', open);
    searchBtn.setAttribute('aria-expanded', String(open));
    if (open) setTimeout(() => searchInput.focus(), 120);
  }
  searchBtn.addEventListener('click', () => setSearchOpen(!searchDD.classList.contains('open')));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setSearchOpen(false); });
  document.addEventListener('pointerdown', (e) => { if (!searchDD.contains(e.target)) setSearchOpen(false); });

  /* Short countdown ticker for panel-card "Ends in" lines — same guarded
     pattern as the main header search; innerHTML injection never executes
     the <script> that rides along in the fetched section HTML. */
  function ensureCdTicker() {
    if (window.__faCdShort) return;
    window.__faCdShort = true;
    const cdTick = () => {
      const els = document.querySelectorAll('[data-fa-cd-short]');
      if (!els.length) return;
      const now = Date.now();
      els.forEach((el) => {
        const t = parseInt(el.getAttribute('data-fa-cd-short'), 10) * 1000;
        if (!t) return;
        const d = t - now;
        if (d <= 0) { el.textContent = 'Deal ended'; return; }
        const days = Math.floor(d / 86400000);
        const hrs = Math.floor((d % 86400000) / 3600000);
        const mins = Math.floor((d % 3600000) / 60000);
        el.textContent = 'Ends in ' + (days > 0 ? days + 'd ' : '') + hrs + 'h ' + mins + 'm';
      });
    };
    cdTick();
    setInterval(cdTick, 60000);
  }

  /* live predictive results — v2: SAME renderer as the main header search
     box. Fetches the server-rendered predictive-search section (which
     outputs fa-product-card 'panel' horizontal cards) and injects the
     products block, instead of templating bare rows from suggest.json. */
  let searchTimer = null, searchSeq = 0;
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      const seq = ++searchSeq;
      try {
        const url = '/search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][unavailable_products]=show' +
          '&resources[options][fields]=title,product_type,variants.title' +
          '&section_id=predictive-search';
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('Suggest failed');
        const html = await res.text();
        if (seq !== searchSeq) return; // a newer query superseded this one
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const block = doc.querySelector('#predictive-search-products');
        if (!block || !block.querySelector('.fa-hcard')) {
          searchResults.innerHTML = '<div class="fa-cartp__empty">No products found for \u201c' + q + '\u201d</div>';
          return;
        }
        /* the section prints a "Products" heading — the panel doesn't need it */
        const heading = block.querySelector('.predictive-search-results__title');
        if (heading) heading.remove();
        searchResults.innerHTML = block.outerHTML +
          '<a class="fa-morph-searchall" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results</a>';
        ensureCdTicker();
      } catch (e) {
        if (seq === searchSeq) searchResults.innerHTML = '<div class="fa-cartp__empty">Search unavailable</div>';
      }
    }, 220);
  });

  /* ---------- RIGHT cluster ---------- */
  const icons = document.createElement('div');
  icons.className = 'fa-morph-ui fa-morph-icons';
  function cloneDD(srcSelector, label) {
    const src = document.querySelector(srcSelector);
    if (!src) return null;
    const c = src.cloneNode(true);
    c.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
    c.classList.add('fa-morph-dd');
    const a = c.querySelector('.fa-action');
    if (a) a.setAttribute('aria-label', label);
    return c;
  }
  const aboutClone = cloneDD('.fa-header-top__about .fa-dd', 'About Us');
  const accountClone = cloneDD('.fa-header-top__actions .fa-dd', 'My Account');
  if (aboutClone) icons.appendChild(aboutClone);
  if (accountClone) icons.appendChild(accountClone);

  const cartDD = document.createElement('div');
  cartDD.className = 'fa-dd fa-morph-cart';
  cartDD.innerHTML =
    '<a class="fa-action" href="/cart" aria-label="Cart">' +
    '<span class="fa-action__icon" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
    '</span>' +
    '<span class="fa-morph-cart-count"></span>' +
    '</a>' +
    '<div class="fa-dd__panel fa-morph-cartpanel" role="menu" aria-label="Cart contents">' +
    '<div class="fa-cartp__items"><div class="fa-cartp__empty">Loading…</div></div>' +
    '<div class="fa-cartp__foot"><span>Subtotal</span><strong class="fa-cartp__subtotal"></strong></div>' +
    '<a class="fa-cartp__btn" href="/cart">View Cart</a>' +
    '</div>';
  icons.appendChild(cartDD);

  botRow.appendChild(leftBox);
  botRow.appendChild(icons);

  /* ---------- live cart ---------- */
  const badge = icons.querySelector('.fa-morph-cart-count');
  const itemsBox = cartDD.querySelector('.fa-cartp__items');
  const subtotalEl = cartDD.querySelector('.fa-cartp__subtotal');
  const money = (cents) => '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  let lastFetch = 0;
  async function fetchCart() {
    lastFetch = Date.now();
    try {
      const cart = await (await fetch('/cart.js')).json();
      if (!cart.items?.length) {
        itemsBox.innerHTML = '<div class="fa-cartp__empty">Your cart is empty</div>';
        subtotalEl.textContent = money(0);
        return;
      }
      itemsBox.innerHTML = cart.items.map((it) =>
        '<div class="fa-cartp__item">' +
        (it.image ? '<img class="fa-cartp__thumb" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_88x88$1$2') + '" alt="">' : '') +
        '<div class="fa-cartp__info">' +
        brandHTML(it.vendor) +
        '<div class="fa-cartp__title">' + it.product_title + '</div>' +
        '<div class="fa-cartp__meta">' + it.quantity + ' × ' + money(it.final_price) + '</div>' +
        '</div>' +
        '<div class="fa-cartp__line">' + money(it.final_line_price) + '</div>' +
        '</div>'
      ).join('');
      subtotalEl.textContent = money(cart.items_subtotal_price);
    } catch (e) {
      itemsBox.innerHTML = '<div class="fa-cartp__empty">Couldn\u2019t load cart</div>';
    }
  }
  cartDD.addEventListener('mouseenter', () => { if (Date.now() - lastFetch > 5000) fetchCart(); });

  const cartSrc =
    topRow.querySelector('.cart-bubble__text-count') ||
    topRow.querySelector('.cart-bubble__text') ||
    topRow.querySelector('.cart-bubble');
  function syncCart() {
    const v = (cartSrc?.textContent || '').replace(/\D/g, '');
    const next = v && v !== '0' ? v : '';
    if (badge.textContent !== next) { badge.textContent = next; fetchCart(); }
  }
  let cartObserver = null;
  if (cartSrc) {
    syncCart();
    cartObserver = new MutationObserver(syncCart);
    cartObserver.observe(cartSrc.parentElement || cartSrc, { childList: true, subtree: true, characterData: true });
  }
  fetchCart();

  /* ---------- wishlist hover panel ---------- */
  const wlLink = [...botRow.querySelectorAll('a')].find((a) => /wishlist/i.test(a.textContent || ''));
  const wlPanel = document.createElement('div');
  wlPanel.className = 'fa-morph-wlpanel';
  wlPanel.innerHTML =
    '<div class="fa-cartp__items"><div class="fa-cartp__empty">Loading…</div></div>' +
    '<a class="fa-cartp__btn" href="/pages/wishlist">View Wishlist</a>';
  botRow.appendChild(wlPanel);
  const wlItemsBox = wlPanel.querySelector('.fa-cartp__items');

  function readWishlistEntries() {
    const candidates = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!/wish/i.test(k)) continue;
      const raw = localStorage.getItem(k);
      let val = raw;
      try { val = JSON.parse(raw); } catch (e) {}
      candidates.push({ k, val });
    }
    for (const { k, val } of candidates) {
      let arr = null;
      if (Array.isArray(val)) arr = val;
      else if (val && typeof val === 'object') {
        for (const key of ['items', 'products', 'handles', 'list', 'wishlist']) {
          if (Array.isArray(val[key])) { arr = val[key]; break; }
        }
      } else if (typeof val === 'string' && val.includes(',')) arr = val.split(',');
      if (arr && arr.length) return { key: k, entries: arr };
    }
    return null;
  }
  function entryHandle(e) {
    if (typeof e === 'string') {
      const m = e.match(/\/products\/([a-z0-9-]+)/i);
      if (m) return m[1];
      if (/^[a-z0-9][a-z0-9-]*$/i.test(e) && !/^\d+$/.test(e)) return e;
      return null;
    }
    if (e && typeof e === 'object') {
      if (e.handle) return e.handle;
      if (e.url) return entryHandle(e.url);
      if (e.product_handle) return e.product_handle;
    }
    return null;
  }
  let wlLastFetch = 0;
  async function fetchWishlist() {
    wlLastFetch = Date.now();
    const data = readWishlistEntries();
    if (!data) {
      wlItemsBox.innerHTML = '<div class="fa-cartp__empty">Couldn\u2019t read wishlist data \u2014 see console</div>';
      return;
    }
    const handles = data.entries.map(entryHandle).filter(Boolean);
    if (!handles.length) {
      wlItemsBox.innerHTML = '<div class="fa-cartp__empty">' + data.entries.length + ' item(s) \u2014 couldn\u2019t resolve to products</div>';
      return;
    }
    const shown = handles.slice(0, 6);
    const products = await Promise.all(
      shown.map((h) => fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null))
    );
    const rows = products.filter(Boolean).map((p) => {
      const img = p.featured_image ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/, '_88x88$1$2') : '';
      return '<a class="fa-cartp__item" href="/products/' + p.handle + '" style="text-decoration:none">' +
        (img ? '<img class="fa-cartp__thumb" src="' + img + '" alt="">' : '') +
        '<div class="fa-cartp__info">' +
        brandHTML(p.vendor) +
        '<div class="fa-cartp__title">' + p.title + '</div>' +
        '<div class="fa-cartp__meta">' + money(p.price) + '</div>' +
        '</div>' +
        '</a>';
    });
    const more = handles.length - shown.length;
    wlItemsBox.innerHTML = rows.length
      ? rows.join('') + (more > 0 ? '<div class="fa-cartp__empty">+ ' + more + ' more</div>' : '')
      : '<div class="fa-cartp__empty">Couldn\u2019t load wishlist products</div>';
  }

  let wlTimer = null;
  function wlSetOpen(open) {
    if (open) {
      clearTimeout(wlTimer);
      const rowRect = botRow.getBoundingClientRect();
      const linkRect = wlLink.getBoundingClientRect();
      let left = linkRect.left + linkRect.width / 2 - 160 - rowRect.left;
      left = Math.max(8, Math.min(left, rowRect.width - 328));
      wlPanel.style.left = left + 'px';
      wlPanel.classList.add('open');
      if (Date.now() - wlLastFetch > 5000) fetchWishlist();
    } else {
      wlTimer = setTimeout(() => wlPanel.classList.remove('open'), 250);
    }
  }
  if (wlLink) {
    wlLink.addEventListener('mouseenter', () => wlSetOpen(true));
    wlLink.addEventListener('mouseleave', () => wlSetOpen(false));
    wlPanel.addEventListener('mouseenter', () => clearTimeout(wlTimer));
    wlPanel.addEventListener('mouseleave', () => wlSetOpen(false));
  }

  /* ---------- alignment: empirical anchors + self-correcting placement ----------
     From the live Chrome session (2026-08-05): the clusters' real containing
     block is NOT the row origin (~34.5px offset), the row rect starts at
     -5.5px, and the content band is NOT symmetric. Anchors come from real
     elements; placement derives the containing-block origin from where the
     cluster ACTUALLY rendered vs its current style.left. */
  function edgeOf(el) {
    const r = el.getBoundingClientRect();
    const cs = getComputedStyle(el);
    const hasBorder = parseFloat(cs.borderLeftWidth) > 0 || parseFloat(cs.borderRightWidth) > 0;
    const bg = cs.backgroundColor;
    const hasBg = bg && bg !== 'transparent' && !/rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0\s*\)/.test(bg);
    if (hasBorder || hasBg) return { left: r.left, right: r.right };
    return {
      left: r.left + (parseFloat(cs.paddingLeft) || 0),
      right: r.right - (parseFloat(cs.paddingRight) || 0),
    };
  }
  function anchors() {
    const W = document.documentElement.clientWidth;
    const hr = document.querySelector('.fa-pdp__header-right');
    if (hr) {
      const right = hr.getBoundingClientRect().right;
      let left = Infinity;
      // prefer named content blocks for the left edge
      for (const s of ['.fa-pdp__breadcrumbs', '.fa-pdp__gallery', '.fa-pdp__media', '.fa-pdp__header-left', '.fa-pdp__header']) {
        const el = document.querySelector(s);
        if (!el) continue;
        const r = el.getBoundingClientRect();
        if (r.width > 200) { left = r.left; break; }
      }
      if (left === Infinity) {
        // generic scan — skip fixed/sticky elements (e.g. the bottom
        // add-to-cart bar is full-bleed and was dragging the edge left)
        document.querySelectorAll('[class*="fa-pdp__"]').forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.width < 200 || r.width > W * 0.92 || r.left < 24) return;
          const pos = getComputedStyle(el).position;
          if (pos === 'fixed' || pos === 'sticky') return;
          if (r.left < left) left = r.left;
        });
      }
      if (left !== Infinity && right - left > 400) return { left, right, src: 'fa-pdp anchors' };
    }
    const foot = document.querySelector('.afd-footer__inner');
    if (foot) {
      const e = edgeOf(foot);
      if (e.right - e.left >= 600) return { left: e.left, right: e.right, src: 'footer inner' };
    }
    const edge = Math.max(0, (W - BAND) / 2) + PAD;
    return { left: edge, right: W - edge, src: 'fallback ' + BAND + 'px band' };
  }

  function matchNavTypography() {
    // labels copy their look from a real nav link, so they always match
    const navLink =
      botRow.querySelector('.menu-list__link') ||
      [...botRow.querySelectorAll('a')].find((a) => !a.closest('.fa-morph-ui') && !a.closest('.fa-morph-wlpanel') && a.textContent.trim());
    if (!navLink) return;
    const cs = getComputedStyle(navLink);
    for (const el of document.querySelectorAll('.fa-morph-ui .fa-action__text')) {
      el.style.fontFamily = cs.fontFamily;
      el.style.fontSize = cs.fontSize;
      el.style.fontWeight = '500'; // one step lighter than the nav — full copy read too bold
      el.style.letterSpacing = cs.letterSpacing;
      el.style.textTransform = cs.textTransform;
    }
  }
  function place() {
    const a = anchors();
    matchNavTypography();
    for (const spec of [{ box: leftBox, mode: 'left' }, { box: icons, mode: 'right' }]) {
      const savedT = spec.box.style.transform;
      spec.box.style.transform = 'translateY(-50%)'; // measure without the entrance offset
      const r = spec.box.getBoundingClientRect();
      if (!r.width) { spec.box.style.transform = savedT; continue; }
      const styleLeft = parseFloat(spec.box.style.left) || 0;
      const base = r.left - styleLeft; // true containing-block origin, whoever it is
      spec.box.style.left = (spec.mode === 'left' ? a.left - base : a.right - r.width - base) + 'px';
      spec.box.style.transform = savedT;
    }
    // wishlist panel top = exactly where the .fa-dd panels land:
    // dd bottom (centered in the bar) + the same 20px offset
    wlPanel.style.top = ((botRow.offsetHeight + cartDD.offsetHeight) / 2 + 20) + 'px';
  }

  /* ---------- scroll-driven morph ---------- */
  const mq = matchMedia('(min-width: 990px)');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let H = topRow.offsetHeight;
  let cur = 0, target = 0, running = false;
  let lastShadow = null;
  const setStickyOffset = () => {
    // top row scrolls off naturally; the bar pins at the viewport top
    section.style.top = mq.matches ? -H + 'px' : '';
  };
  setStickyOffset();
  const clamp = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);

  function writeFrame() {
    const p = reduceMotion.matches ? target : cur;
    const e = p * p * (3 - 2 * p);
    cols.style.opacity = String(clamp(1 - e * 0.9)); // top row fades as it exits
    const L = clamp((e - 0.3) / 0.7);
    leftBox.style.opacity = String(L);
    leftBox.style.transform = 'translateY(-50%) translateX(' + (1 - L) * -44 + 'px)';
    icons.style.opacity = String(L);
    icons.style.transform = 'translateY(-50%) translateX(' + (1 - L) * 44 + 'px)';
    const on = L > 0.6 ? 'auto' : 'none';
    leftBox.style.pointerEvents = on;
    icons.style.pointerEvents = on;
    if (L <= 0.6) setSearchOpen(false);
    const shadow = e > 0.9 ? '0 2px 10px rgba(0,0,0,.18)' : 'none';
    if (shadow !== lastShadow) { botRow.style.boxShadow = shadow; lastShadow = shadow; }
  }

  function tick() {
    cur += (target - cur) * LERP;
    if (Math.abs(target - cur) < 0.002) {
      cur = target; writeFrame(); running = false; return;
    }
    writeFrame();
    requestAnimationFrame(tick);
  }

  function onScroll() {
    if (!mq.matches) return;
    target = clamp((document.scrollingElement?.scrollTop ?? 0) / H);
    if (!running) { running = true; requestAnimationFrame(tick); }
  }

  function reset() {
    cols.style.opacity = '';
    leftBox.style.opacity = '0';
    icons.style.opacity = '0';
    botRow.style.boxShadow = '';
    setSearchOpen(false);
    wlPanel.classList.remove('open');
    cur = target = 0; lastShadow = null;
  }

  function onResize() {
    if (!mq.matches) { reset(); setStickyOffset(); return; }
    H = topRow.offsetHeight || H;
    setStickyOffset();
    writeFrame();
    place();
  }

  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onResize);
  mq.addEventListener('change', onResize);
  place(); place(); // second pass converges once the first establishes the base
  setTimeout(place, 800); // late fonts/glyphs
  if (document.fonts?.ready) document.fonts.ready.then(onResize);
  addEventListener('load', onResize);
  onScroll();

  window.__faMorph = { place, fetchWishlist };

  /* --- watchdog: the theme re-renders the header shortly after load,
     which detaches injected nodes. If that happens, tear down and
     rebuild against the fresh DOM (capped so it can never loop). --- */
  const attached = () => leftBox.isConnected && icons.isConnected && wlPanel.isConnected;
  const rebuild = () => {
    if (window.__faMorphGen !== myGen) return; // a newer instance owns the page
    if (attached()) return;
    window.__faMorphRebuilds = (window.__faMorphRebuilds || 0) + 1;
    if (window.__faMorphRebuilds > 5) return;
    try { watchdogMO.disconnect(); } catch (e) {}
    // remove EVERY morph element on the page, not just this instance's
    document.querySelectorAll('.fa-morph-ui, .fa-morph-wlpanel, #fa-morph-style').forEach((n) => n.remove());
    cartObserver?.disconnect();
    window.__faMorph = undefined;
    init();
  };
  const watchdogMO = new MutationObserver(rebuild);
  watchdogMO.observe(document.body, { childList: true, subtree: true });
  [400, 1200, 3000, 6000].forEach((ms) => setTimeout(rebuild, ms));
  setTimeout(() => watchdogMO.disconnect(), 12000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();